// Provides context and refs for the zoom/pan system
import React, { createContext, useContext, useMemo } from 'react'

const ZoomPanContext = createContext()

export function ZoomPanProvider({ children, isReady, zoomPanRefs, zoomPanUtils }) {
  const value = useMemo(
    () => ({
      isReady,
      isZoomPanReady: isReady,
      zoomPanUtils,
      ...zoomPanRefs,
    }),
    [isReady, zoomPanRefs, zoomPanUtils]
  )

  return <ZoomPanContext.Provider value={value}>{children}</ZoomPanContext.Provider>
}

export default function useZoomPanContext() {
  return useContext(ZoomPanContext)
}
